import { Observable } from 'rxjs';
import { AppService } from 'app/services/app.service';
import {
  MetaBusinessResponse,
  EmbeddedSignupStateResponse,
  EmbeddedSignupCompleteRequest,
  MetaBusinessPatchRequest,
  MetaBusinessPatchResponse,
  MetaBusinessDeleteResponse,
  MetaBusinessTemplate,
  MetaBusinessMensagemRequest,
  MetaBusinessMensagemResponse,
  MetaBusinessAccountsGetResponse,
  MetaBusinessAccountsPostResponse,
  MetaBusinessAccountsPostRequest,
  MetaBusinessAccountsDeleteRequest,
  MensagemTesteHistoricoResponse
} from 'app/pages/full-pages/integrador/whatsapp/models/whatsapp-business.models';

export abstract class AbWhatsAppBusiness extends AppService {
  /** GET /admin/v1/integrador/meta-business — consulta status da integração */
  abstract consultarStatus(): Observable<MetaBusinessResponse>;

  /** POST /admin/v1/integrador/meta-business/state — gera state para Embedded Signup */
  abstract gerarState(): Observable<EmbeddedSignupStateResponse>;

  /** POST /admin/v1/integrador/meta-business/complete — completa cadastro após Embedded Signup */
  abstract completarCadastro(dados: EmbeddedSignupCompleteRequest): Observable<MetaBusinessResponse>;

  /** PATCH /admin/v1/integrador/meta-business — edição/atualização com PIN opcional */
  abstract atualizarIntegracao(dados: MetaBusinessPatchRequest): Observable<MetaBusinessPatchResponse>;

  /** DELETE /admin/v1/integrador/meta-business — remove integração */
  abstract removerIntegracao(metaPhoneNumberId: string): Observable<MetaBusinessDeleteResponse>;

  /** GET /admin/v1/integrador/meta-business/simulacao/template — busca template de simulação */
  abstract buscarTemplate(): Observable<MetaBusinessTemplate>;

  /** POST /admin/v1/integrador/meta-business/mensagens — envia mensagem de teste */
  abstract enviarMensagemTeste(dados: MetaBusinessMensagemRequest): Observable<MetaBusinessMensagemResponse>;

  /** POST (endpoint a definir) — reenvia templates padrão para a Meta */
  abstract reenviarTemplates(): Observable<MetaBusinessResponse>;

  /** GET /admin/v1/integrador/meta-business/accounts */
  abstract buscarContas(): Observable<MetaBusinessAccountsGetResponse>;

  /** POST /admin/v1/integrador/meta-business/accounts*/
  abstract cadastrarContas(contas: MetaBusinessAccountsPostRequest): Observable<MetaBusinessAccountsPostResponse>;

  /** DELETE /admin/v1/integrador/meta-business/accounts */
  abstract excluirContas(contas: MetaBusinessAccountsDeleteRequest): Observable<void>;

  /** GET /admin/v1/integrador/meta-business/mensagens/historico */
  abstract buscarHistoricoMensagens(): Observable<MensagemTesteHistoricoResponse>;
}
